// extracted by mini-css-extract-plugin
var _1 = "AICheckbox-moduleaiBounding__SKvEj";
var _2 = "AICheckbox-moduleaiCheckbox__Bll6O";
export { _1 as "aiBounding", _2 as "aiCheckbox" }
